import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/zillehuma/zysoftec/source/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/home/zillehuma/zysoftec/source/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/zillehuma/zysoftec/source/public/images/case-study/nujoom-zysoftec.png");
;
import(/* webpackMode: "eager" */ "/home/zillehuma/zysoftec/source/public/images/case-study/org.png");
;
import(/* webpackMode: "eager" */ "/home/zillehuma/zysoftec/source/public/images/case-study/seller_app.png");
;
import(/* webpackMode: "eager" */ "/home/zillehuma/zysoftec/source/public/images/services/custom.png");
